import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1653642780303'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='10379'
    >
        <path
            d='M958.5 336.4c-2.9-10-29.2-98.4-77.6-137.1-43.7-35-87-56.8-88.9-57.7-16.4-8.2-36.3-1.6-44.5 14.8-8.2 16.4-1.6 36.3 14.8 44.5 0.4 0.2 39.1 19.7 77.1 50.2 22.9 18.4 44.5 68.7 53.9 99.2v426.2c-0.4 15.3-6.4 33.6-33.2 33.6-26.7 0-32.8-18.3-33.2-33.2V403.6c0-67-59.5-91.3-99.6-91.3h-33.2V187c0-52.8-54.1-106.9-106.9-106.9H237c-52.8 0-106.9 54.1-106.9 106.9v689.6H96.9c-18.3 0-33.2 14.8-33.2 33.2 0 18.4 14.9 33.2 33.2 33.2h630.5c18.4 0 33.2-14.8 33.2-33.2 0-18.4-14.8-33.2-33.2-33.2h-33.2V378.8h32.9c10.1 0.2 33.5 3 33.5 24.9V777c0 40 26.5 99.6 99.6 99.6s99.6-59.5 99.6-99.6V345.6c0-3.1-0.5-6.2-1.3-9.2z m-430.2 9.2H296c-18.3 0-33.2-14.9-33.2-33.2 0-18.3 14.9-33.2 33.2-33.2h232.3c18.3 0 33.2 14.9 33.2 33.2 0 18.3-14.8 33.2-33.2 33.2z'
            p-id='10380'
            fill='currentColor'
        ></path>
    </svg>
)

export const ConsumableUsageIcon = props => <Icon component={SVG} {...props} />
